import { render } from "./IndexOrganizations.vue?vue&type=template&id=0d7bff7e"
import script from "./IndexOrganizations.vue?vue&type=script&lang=js"
export * from "./IndexOrganizations.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__